'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsChecklists', ['$scope', 'IPTemplates', '$rootScope', function ($scope, IPTemplates, $rootScope) {
        $scope.loading = true;

        IPTemplates.get().then(function (checklists) {
            $scope.checklists = checklists;
            $scope.loading = false;
        })

        $scope.columns = [
            {
                label: 'Name',
                field: 'name',
                link: {
                    state: 'internal.inspecting.resource.checklist.layout',
                    params: [
                        {
                            name: 'id',
                            field: 'id'
                        },
                        {
                            name: 'checklist',
                            field: ''
                        }
                    ]
                },
                html: '<span ng-if="$parent.$parent.record.published" class="icon glyphicon glyphicon-lock" title="Published"></span>'
            },
            {
                label: 'Type',
                field: 'inspection_type',
                type: 'entity'
            },
            {
                label: 'Last Modified',
                field: 'modifiedon',
                type: 'date'
            },
            {
                label: 'Modified By',
                field: 'modifiedby'
            }
        ];

        $scope.filters = [            
            {
                name: 'All Checklist Types',
                field: 'inspection_type',
                options: [
                    { name: $rootScope.enterprise.serviceLabels['SERVICE'], id: 'service' },
                    { name: $rootScope.enterprise.vehicleLabels['VEHICLE'], id: 'vehicle' }
                ]
            },
            {
                name: 'Archived',
                field: 'archive',
                options: [
                    { name: 'Un-Archived', id: false },
                    { name: 'Archived', id: true }
                ]
            }
        ];
    }])
;